import { tiltify } from "@playlive/tiltify-lib";
import { useQuery } from "@tanstack/react-query";
import { useCallback } from "preact/hooks";
import PropTypes from "prop-types";
import GCXPollSelector from "./gcx-poll-selector.jsx";

const gcxCampaignID = import.meta.env.VITE_GCX_CAMPAIGN_ID;

GCXCustomizePolls.propTypes = {
  onPollSelected: PropTypes.func.isRequired,
  pollID: PropTypes.any,
};

export default function GCXCustomizePolls({ onPollSelected, pollID }) {
  const { data: polls, isLoading } = useQuery({
    queryKey: ["gcxCustomizePolls", gcxCampaignID],
    initialData: [],
    queryFn: () => {
      return tiltify.GetPolls(gcxCampaignID);
    },
    staleTime: 60000,
    refetchInterval: 60000,
  });

  const handlePollSelection = useCallback(
    ({ id }) => {
      onPollSelected(id);
    },
    [onPollSelected],
  );

  return (
    <GCXPollSelector
      onPollSelected={handlePollSelection}
      polls={polls}
      pollsLoading={isLoading}
      pollID={pollID}
    />
  );
}
